export default __webpack_public_path__ + "static/media/collection.6a45d9c8.svg";